import React from 'react'
import { Box } from '@chatterbug/aaron'
import routes from 'src/lib/rails-routes/rails-routes'

export type Props = {
  login: string
  interactionStyles: Record<string, unknown>
}

const UserLogin: React.FC<Props> = ({ login, interactionStyles }) => {
  return (
    <Box
      as="a"
      href={routes.profile(login)}
      color="black0"
      sx={{
        ...interactionStyles,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {login}
    </Box>
  )
}

export default UserLogin
